// Restructured to nested form to match component usage:
// `t('title')`, `t('tabs.profile')`, `t('profileTab.contactInfo')`,
// `t('subscriptionTab.currentPlan')`, `t('editModal.fullName')`, etc.
export const profile = {
  title: "Settings",

  // Cross-namespace shortcut — page uses `t('common.back')` which i18next
  // resolves to `common.back` inside this namespace (`.` = nested, not ns).
  common: {
    back: "Back",
  },

  tabs: {
    profile: "Profile",
    subscription: "Subscription",
  },

  profileTab: {
    friendlyStats: "Friendly Matches",
    rankedStats: "Acework Ranked",
    pointsByLevel: "Points by Level",
    memberSince: "Member since",
    copied: "Copied",
    contactInfo: "Contact Information",
    email: "Email",
    phone: "Phone",
    location: "Location",
    preferences: "Preferences",
    notifications: "Notifications",
    notificationsDesc: "Match reminders and updates",
    privacy: "Privacy",
    privacyDesc: "Profile visibility settings",
    security: "Security",
    securityDesc: "Password and authentication",
    logout: "Sign Out",
  },

  subscriptionTab: {
    tiers: {
      free: {
        name: "Free",
        price: "$0/month",
        features: [
          "Up to 5 friendly pickup posts / month",
          "Join any pickup or tournament",
          "Personal match history",
          "No Acework Ranked tagging",
        ],
      },
      pro: {
        name: "Pro",
        price: "$5.99/month",
        features: [
          "Unlimited pickup posts",
          "Acework Ranked Pickup matches (1v1)",
          "Acework Ranked Tournaments up to 8 players",
          "City leaderboard placement",
          "Acework Verified badge",
        ],
        cta: "Upgrade to Pro",
      },
      elite: {
        name: "Elite",
        price: "$19.99/month",
        features: [
          "Everything in Pro",
          "Acework Ranked Tournaments up to 32+ players",
          "Year-end finals qualification",
          "Elite badge on profile",
          "Priority support",
        ],
        cta: "Upgrade to Elite",
      },
    },
    currentPlan: "Current Plan",
    upgrade: {
      comingSoon: "In-app subscriptions coming soon. Stay tuned!",
    },
  },

  editModal: {
    title: "Edit Profile",
    fullName: "Full Name",
    namePlaceholder: "Enter your name",
    email: "Email Address",
    emailPlaceholder: "your@email.com",
    phone: "Phone Number",
    phonePlaceholder: "+1 (555) 000-0000",
    country: "Country",
    city: "City",
    cityCustom: "Your City",
    location: "Location",
    locationPlaceholder: "City, Country",
    ntrpRating: "Skill Level (NTRP)",
    cancel: "Cancel",
    save: "Save Changes",
    saving: "Saving...",
  },

  // Legacy flat keys — kept for backwards compatibility with any old code paths.
  ntrp: "NTRP",
};
